import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectViewMode = createSelector(
  [(store: RootState) => store.documentsList.viewMode],
  (data) => data
);
